import { Table } from 'antd';
import { FC } from 'react';

const TableCreate: FC<{ data: any[]; page: number }> = ({ data, page }) => {
  const columns: any = [
    {
      title: 'No.',
      dataIndex: 'name',
      key: 'name',
      width: '5%',
      align: 'center',
      render(_text: string, _row: any, index: number) {
        return {
          props: {
            style: { background: 'rgba(246, 246, 246, 1)', textAlign: 'left' },
            className: 'standardFont',
          },
          children: <div>{(page - 1) * 50 + index + 1}</div>,
        };
      },
    },
    {
      title: 'ID',
      dataIndex: 'patient_id',
      key: 'patient_id',
      width: '10%',
      align: 'center',
      render(text: string) {
        return {
          props: {
            style: { textAlign: 'left' },
            className: 'standardFont',
          },
          children: <div>{text}</div>,
        };
      },
    },
    {
      title: 'ご利用者名',
      dataIndex: 'cpap_id',
      key: 'cpap_id',
      width: '15%',
      align: 'center',
      render(text: any) {
        return {
          props: {
            style: { background: 'rgba(246, 246, 246, 1)', textAlign: 'left' },
            className: 'standardFont',
          },
          children: <div>{text}</div>,
        };
      },
    },
    {
      title: 'CPAP請求月',
      key: 'target_month',
      dataIndex: 'target_month',
      width: '15%',
      align: 'center',
      render(text: string) {
        return {
          props: {
            style: { textAlign: 'left' },
            className: 'standardFont',
          },
          children: <div>{text ? `${text.slice(0, 4)}年${Number(text.slice(4))}月` : ''}</div>,
        };
      },
    },
    {
      title: '備考',
      key: 'hospital_visit_remark',
      dataIndex: 'hospital_visit_remark',
      width: '40%',
      align: 'center',
      render(text: string) {
        return {
          props: {
            style: { background: 'rgba(246, 246, 246, 1)', textAlign: 'left', paddingLeft: '10px' },
            className: 'standardFont',
          },
          children: <div>{text}</div>,
        };
      },
    },
  ];

  return (
    <div>
      <Table columns={columns} dataSource={data} pagination={false} />
    </div>
  );
};

export default TableCreate;
